import React from "react";
import { Tooltip, Typography } from "@mui/material";

/**
 * Truncates long text in table cells and shows full value on hover.
 */
const TruncatedText = ({
  value,
  emptyLabel = "—",
  maxWidth = "100%",
  variant = "body2",
  sx = {},
}) => {
  const text = value === 0 ? "0" : value || "";

  if (!text) {
    return (
      <Typography variant={variant} color="text.secondary">
        {emptyLabel}
      </Typography>
    );
  }

  return (
    <Tooltip title={String(text)} arrow placement="top">
      <Typography
        variant={variant}
        noWrap
        sx={{
          maxWidth,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "block",
          ...sx,
        }}
      >
        {String(text)}
      </Typography>
    </Tooltip>
  );
};

export default TruncatedText;
